export default [
    {
        path: 'relatorio-posicao-estoque',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-relatorio-posicao-estoque' */
            '@/views/almoxarifado/relatorio-posicao-estoque/Index'
        ),
        redirect: 'relatorio-posicao-estoque/index',
        children: [
            {
                name: 'almoxarifado-relatorio-posicao-estoque-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-relatorio-posicao-estoque' */
                    '@/views/almoxarifado/relatorio-posicao-estoque/List.vue'
                ),
            },
        ],
    },
]